const products = [
      {
        "id": 1,
        "titulo": "Umusic",
        "imagem": "https://firebasestorage.googleapis.com/v0/b/nulamar-2547e.appspot.com/o/projects%2Fsmartmockups_lzaa74cz.jpg?alt=media&token=e134ea40-617f-49df-814a-aae5518b1a0f",
        "descricao": "Plataforma de streaming que oferece acesso a músicas licenciadas sob Creative Commons ou domínio público.",
        "responsaveis_tecnicos": "Ezequiel Sousa",
        "link_acesso": "https://example.com/produtos/periodicos_software"
      },
      {
        "id": 2,
        "titulo": "EasyLib",
        "imagem": "https://firebasestorage.googleapis.com/v0/b/nulamar-2547e.appspot.com/o/projects%2Fsmartmockups_lzaidao4.jpg?alt=media&token=d398239a-455c-4328-8c6a-fed18170c5f5",
        "descricao": "Plataforma que oferece acesso a obras licenciadas sob Creative Commons ou domínio público.",
        "responsaveis_tecnicos": "Ezequiel Sousa",
        "link_acesso": "https://example.com/produtos/marketing_digital"
      },
      {
        "id": 3,
        "titulo": "ProntoPet",
        "imagem": "https://i1.wp.com/blog.creativecopias.com.br/wp-content/uploads/2015/10/Mockup02.jpg?fit=700%2C353&ssl=1",
        "descricao": "Um aplicativo eficiente para gerenciar suas tarefas diárias.",
        "responsaveis_tecnicos": "Ezequiel Sousa",
        "link_acesso": "https://youtube.com"
      }
    ]

    export default products;
